<template>
  <div/>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

const store = useStore<RootState>();

defineOptions({
  name: 'dataEmailTemplates',
});

// Базовый тип для сообщений с ID шаблона email
type EmailTemplateWithId = {
  idEmailTemplate: number;
};

// Типы для WebSocket сообщений компонента emailTemplates
type EmailTemplatesListMessage = WebSocketMessageWithFields<'language-email-template-list', {
  emailTemplates: unknown[];
}>;
type EmailTemplateTranslationsMessage = WebSocketMessageWithFields<'language-email-template-translations', {
  emailTemplate: unknown;
}>;
type EmailTemplateCreateMessage = WebSocketMessageWithFields<'language-email-template-create' | 'language-email-template-create-success', EmailTemplateWithId & {
  name: string;
}>;
type EmailTemplateDeleteMessage = WebSocketMessageWithFields<'language-email-template-delete' | 'language-email-template-delete-success', EmailTemplateWithId>;

// Объединенный тип для всех сообщений
type EmailTemplatesWebSocketMessage = 
  | EmailTemplatesListMessage 
  | EmailTemplateTranslationsMessage 
  | EmailTemplateCreateMessage 
  | EmailTemplateDeleteMessage;

// WebSocket message handler
const handleWebSocketMessage = (data: EmailTemplatesWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'language-email-template-list':
      store.dispatch('emailTemplates/wsSetEmailTemplates', { emailTemplates: data.emailTemplates });
      break;

    case 'language-email-template-translations':
      store.dispatch('emailTemplate/wsSetEmailTemplate', data.emailTemplate);
      break;

    case 'language-email-template-create':
    case 'language-email-template-create-success':
      store.dispatch('emailTemplates/wsEmailTemplateCreate', {
        idEmailTemplate: data.idEmailTemplate,
        name: data.name,
      });
      break;

    case 'language-email-template-delete':
    case 'language-email-template-delete-success':
      store.dispatch('emailTemplates/wsEmailTemplateDelete', { idEmailTemplate: data.idEmailTemplate });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);
</script>
